const { STRAPI } = require("../loaders/global");

const BASE_URL = `${process.env.NEXT_PUBLIC_UPLOAD_BASE_URL}`;

export const generateAlt = (image, defaultAlt = "", add = null) => {
  return image?.data?.attributes?.alternativeText
    ? image?.data?.attributes?.alternativeText + (add ? " " + add : "")
    : defaultAlt;
};

const imageToURL = (image, format = "medium") => {
  if (format == "url") return BASE_URL + image?.data?.attributes?.url;
  try {
    return BASE_URL + getMaxFormat(image.data.attributes.formats, format);
  } catch (error) {
    try {
      return BASE_URL + image?.data?.attributes?.url;
    } catch (error) {
      return BASE_URL;
    }
  }
};

export const getMaxFormat = (formats, formatTarget) => {
  let formatOrder = ["thumbnail", "small", "medium", "large"];
  let indexTarget = formatOrder.indexOf(formatTarget);
  let targetsFormat = formatOrder.splice(0, indexTarget + 1).reverse();
  let res = null;

  for (let i = 0; i < targetsFormat.length; i++) {
    const format = targetsFormat[i];

    try {
      res = formats[format].url;
      break;
    } catch (err) {}
  }
  if (!res) throw new Error("No formats found");
  return res;
};

export default imageToURL;
